/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PublicMonitorV2DatapointQualificationDto } from './PublicMonitorV2DatapointQualificationDto';
import type { PublicMonitorV2DatapointSpecialDateDto } from './PublicMonitorV2DatapointSpecialDateDto';

/**
 * Datapoint of a monitor
 */
export type PublicMonitorV2DatapointDto = {
    /**
     * Anomaly status given by the model. It is never overwritten by a user qualification
     */
    anomalyStatus: PublicMonitorV2DatapointDto.anomalyStatus;
    /**
     * Whether the datapoint was evaluated in the run. Only returned when a runId is provided
     */
    evaluatedInRun?: boolean;
    /**
     * Whether the datapoint is obsolete and no longer taken into account
     */
    isObsolete: boolean;
    /**
     * Lower bound of the expected range
     */
    lowerBound: number | null;
    /**
     * Values of the compared metrics by metric name. Only returned for an interlinked metrics monitor
     */
    metrics?: Record<string, number>;
    /**
     * Value predicted by the model
     */
    predictedValue: number | null;
    qualification?: PublicMonitorV2DatapointQualificationDto;
    /**
     * Special dates matching the datapoint
     */
    specialDates?: Array<PublicMonitorV2DatapointSpecialDateDto>;
    /**
     * Timestamp of the datapoint
     */
    timestamp: string;
    /**
     * Upper bound of the expected range
     */
    upperBound: number | null;
    /**
     * Observed value. For an interlinked metrics monitor, difference between the metrics
     */
    value: number | null;
};

export namespace PublicMonitorV2DatapointDto {

    /**
     * Anomaly status given by the model. It is never overwritten by a user qualification
     */
    export enum anomalyStatus {
        ANOMALY = 'ANOMALY',
        NOT_ANOMALY = 'NOT_ANOMALY',
    }


}
